import HeadroomController from "./components/HeadroomController";
import HeaderVideoController from "./components/HeaderVideoController";
import CookiesPlugin from './components/CookiesPlugin';
import FormStepsController from "./components/FormStepsController";
import MasonryController from "./components/MasonryController";
import VideoSlider from "./components/VideoSlider";
import BasicForm from "./components/BasicForm";
import MobileNavigation from "./components/MobileNavigation";
import AOSHandler from "./components/AOSHandler";

export default class Index {
    constructor() {
        this.init();
    }

    init() {
        new HeadroomController();
        new HeaderVideoController();
        new CookiesPlugin();
        new FormStepsController();
        new MasonryController();
        new VideoSlider();
        new BasicForm();
        new MobileNavigation();
        new AOSHandler();
    }
}
